module.exports = __webpack_public_path__ + "static/img/logo.a1de9fd0.svg";